import axios from "axios";
import AppConfig from "appConfig";

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = AppConfig.api_base_url;
axiosInstance.defaults.headers.common.token = localStorage.getItem(AppConfig.auth_token);
axiosInstance.defaults.headers.common.dashboard = AppConfig.dashboard;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || "Something went wrong!")
);

export default axiosInstance;
